import * as PolynomialValueTask from "../../generators/dzial2_algebra/temat7_wielomiany/podtemat1_pojecie_types/PolynomialValueTask";
import PolynomialOperationsPreparationTheory from "./PolynomialOperationsPreparationTheory";
import {getMaturaCourseCode} from "../maturaCourseCodes";
import * as SimplifyParenthesesTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types/SimplifyParenthesesTask";
import * as MultiplyBinomialsTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types/MultiplyBinomialsTask";
import * as LogComputePowerTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat3_obliczanie_types/LogComputePowerTask";
import * as LogPropCoefMixTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropCoefMixTask";
import * as OddRoots from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat5_dzialania_na_pierwiastkach_types/OddRootValueTask";
import * as FractionRoots from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat5_dzialania_na_pierwiastkach_types/FractionRootProductTask";
import * as FactorSum from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowFactorSumTask";
import * as InverseInterest from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/InverseCompoundInterestTasks";
import * as RootSumCubeClosedTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RootSumCubeClosedTask";
import {
  ABSOLUTE_VALUE_CODE,
  ROOT_OPERATIONS_CODE,
  PERCENTAGES_CODE,
  POWERS_CODE,
  LOGARITHMS_CODE,
  SPECIAL_PRODUCTS_CODE,
  RATIONAL_EXPRESSIONS_EQUATIONS_CODE,
  QUADRATIC_INEQUALITIES_CODE,
  LINEAR_INEQUALITIES_CODE,
  POLYNOMIAL_EQUATIONS_CODE,
  POLYNOMIAL_OPERATIONS_CODE,
  LINEAR_SYSTEMS_WORD_PROBLEMS_CODE,
  FUNCTION_GRAPH_CODE,
  LINEAR_FUNCTION_CODE,
  QUADRATIC_CANONICAL_CODE,
  QUADRATIC_FACTORED_CODE,
  QUADRATIC_OPTIMIZATION_CODE,
  SEQUENCE_BASICS_CODE,
  ARITHMETIC_SEQUENCE_CODE,
  GEOMETRIC_SEQUENCE_CODE,
  MIXED_SEQUENCES_CODE,
  ACUTE_ANGLE_TRIG_CODE,
  TRIG_IDENTITIES_CODE,
  TRIANGLE_RADII_CODE,
  TRIANGLE_SIMILARITY_CODE,
  TRIANGLE_AREA_COSINE_CODE,
  CIRCLE_ANGLES_CODE,
  SIMILARITY_SCALE_CODE,
  ANALYTIC_GEOMETRY_APPLICATIONS_CODE,
  LINES_POSITION_CODE,
  CIRCLE_EQUATION_CODE,
  PRISMS_PYRAMIDS_CODE,
  CYLINDER_CONE_CODE,
  COMBINATORICS_CODE,
  PROBABILITY_BASICS_CODE,
  DESCRIPTIVE_STATISTICS_CODE,
  DIVISIBILITY_PROOFS_CODE,
} from "./maturaCoursePreparationAvailability";
import * as AbsIntValueTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat2_wartosc_bezwzgledna_types/AbsIntValueTask";
import * as AbsSqrtMinusIntValueTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat2_wartosc_bezwzgledna_types/AbsSqrtMinusIntValueTask";
import * as AbsSqrtAbsPairOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat2_wartosc_bezwzgledna_types/AbsSqrtAbsPairOpenTask";
import * as PercentOfNumberTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat1_procenty_obliczanie_types/PercentOfNumberTask";
import * as PercentWhatPartTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat1_procenty_obliczanie_types/PercentWhatPartTask";
import * as PercentComparisonRelativeTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat3_porownania_procentowe_types/PercentComparisonRelativeTask";
import * as FindFinalAmountSimpleInterestTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/FindFinalAmountSimpleInterestTask";
import * as FindFinalAmountSingleCapitalizationTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/FindFinalAmountSingleCapitalizationTask";
import * as SolveAbsoluteLinearTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat4_wartosci_bezwgledne_types/SolveAbsoluteLinearTask";
import * as ExtractRootFactorTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat5_dzialania_na_pierwiastkach_types/ExtractRootFactorTask";
import * as RootSumSquareClosedTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RootSumSquareClosedTask";
import * as RootBinomialOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RootBinomialOpenTask";
import * as PowSumExponentsTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowSumExponentsTask";
import * as PowDiffExponentsTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowDiffExponentsTask";
import * as PowPowerOfPowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowPowerOfPowerTask";
import * as NegativeExponentBasicTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat2_potegi_calkowite_types/NegativeExponentBasicTask";
import * as RadicalToRationalPowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat3_potegi_wymierne_types/RadicalToRationalPowerTask";
import * as PowerFamilyPreparationTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowerFamilyPreparationTask";
import * as LogSimpleTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat1_definicja_types/LogSimpleTask";
import * as LogNumberAsLogTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogNumberAsLogTask";
import * as LogPropSumTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropSumTask";
import * as LogPropDiffTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropDiffTask";
import * as LogPropCoefTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropCoefTask";
import * as SquareOfSumLiteralTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfSumLiteralTask";
import * as SquareOfDifferenceTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfDifferenceTask";
import * as DifferenceOfSquaresTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/DifferenceOfSquaresTask";
import * as SquareOfSumTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfSumTask";
import * as SquareOfDifferenceSqrtTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfDifferenceSqrtTask";
import * as DifferenceOfSquaresWithRootTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/DifferenceOfSquaresWithRootTask";
import * as MixedSpecialProductsSqrtTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/MixedSpecialProductsSqrtTask";
import * as CancelBracketFactorTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat3_ulamki_algebraiczne_types/CancelBracketFactorTask";
import * as DiffSquaresOverSumOrDiffTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat3_ulamki_algebraiczne_types/DiffSquaresOverSumOrDiffTask";
import * as RationalSolveAndDomainLinearTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalSolveAndDomainLinearTask";
import * as RationalSolveAndDomainLinearConstTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalSolveAndDomainLinearConstTask";
import * as RationalTwoFracsQuadraticTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalTwoFracsQuadraticTask";
import * as SolveQuadraticTwoSolutionsTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/SolveQuadraticTwoSolutionsTask";
import * as SolveRearrangedQuadraticTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/SolveRearrangedQuadraticTask";
import * as QuadraticFactoredInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types/QuadraticFactoredInequalityTask";
import * as QuadraticGeneralInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types/QuadraticGeneralInequalityTask";
import * as RearrangedQuadraticInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types/RearrangedQuadraticInequalityTask";
import * as SolveTwoSidedLinearEquationTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/SolveTwoSidedLinearEquationTask";
import * as SolveLinearEquationWithParenthesesTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/SolveLinearEquationWithParenthesesTask";
import * as LinearEquationFractionsTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/LinearEquationFractionsTask";
import * as LinearInequalitySimpleTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat1_liniowe_types/LinearInequalitySimpleTask";
import * as LinearInequalityTwoSidesTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat1_liniowe_types/LinearInequalityTwoSidesTask";
import * as LinearInequalityFractionsTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat1_liniowe_types/LinearInequalityFractionsTask";
import * as ProductFactorsPolynomialEquationTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat5_wielomianowe_types/ProductFactorsPolynomialEquationTask";
import * as LinearSystemSubstitutionEasyTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat1_podstawianie_types/LinearSystemSubstitutionEasyTask";
import * as TwoNumbersSumDiffTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat2_wspolczynniki_types/TwoNumbersSumDiffTask";
import * as TicketsSalesTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat2_wspolczynniki_types/TicketsSalesTask";
import * as ReadDomainFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadDomainFromGraphTask";
import * as ReadRangeFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadRangeFromGraphTask";
import * as ReadFunctionValueFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadFunctionValueFromGraphTask";
import * as ReadZeroFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadZeroFromGraphTask";
import * as ReadMonotonicityFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadMonotonicityFromGraphTask";
import * as ReadSignIntervalFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadSignIntervalFromGraphTask";
import * as ReadFunctionComparisonIntervalFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadFunctionComparisonIntervalFromGraphTask";
import * as ReadMaximumOnIntervalFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadMaximumOnIntervalFromGraphTask";
import * as LinearComputeValueTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat1_wzor_types/LinearComputeValueTask";
import * as LinearZeroTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/LinearZeroTask";
import * as LinearSlopeTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat1_wzor_types/LinearSlopeTask";
import * as LinearFromTwoPointsTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat1_wzor_types/LinearFromTwoPointsTask";
import * as ShiftFunctionByVectorTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/ShiftFunctionByVectorTask";
import * as FindAPQFromCanonicalTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat2_kanoniczna_types/FindAPQFromCanonicalTask";
import * as FindVertexFromGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types/FindVertexFromGeneralTask";
import * as TransformGeneralToCanonicalTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat2_kanoniczna_types/TransformGeneralToCanonicalTask";
import * as TransformCanonicalToGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat2_kanoniczna_types/TransformCanonicalToGeneralTask";
import * as FindAX1X2FromFactoredTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat3_iloczynowa_types/FindAX1X2FromFactoredTask";
import * as FindRootsFromGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types/FindRootsFromGeneralTask";
import * as TransformGeneralToFactoredTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat3_iloczynowa_types/TransformGeneralToFactoredTask";
import * as TransformFactoredToGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat3_iloczynowa_types/TransformFactoredToGeneralTask";
import * as QuadraticExtremeArgTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/QuadraticExtremeArgTask";
import * as QuadraticExtremeValueTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/QuadraticExtremeValueTask";
import * as QuadraticExtremeOnIntervalTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/QuadraticExtremeOnIntervalTask";
import * as FenceMaxAreaAgainstWallTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/FenceMaxAreaAgainstWallTask";
import * as OptimizationPairsTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/OptimizationPairsTask";
import * as FindNthTermFromFormulaTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat1_definicja_types/FindNthTermFromFormulaTask";
import * as SumInitialTermsFromFormulaTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat1_definicja_types/SumInitialTermsFromFormulaTask";
import * as CompleteRecursiveTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat3_rekurencyjny_types/CompleteRecursiveTask";
import * as FindNthTermTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/FindNthTermTask";
import * as FindDifferenceTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/FindDifferenceTask";
import * as FindSumTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat2_suma_types/FindSumTask";
import * as ArithmeticMiddleTermTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/ArithmeticMiddleTermTask";
import * as ArithmeticMiddleTermEquationTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/ArithmeticMiddleTermEquationTask";
import * as FindNthTermGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/FindNthTermGeoTask";
import * as GeometricConsecutiveRatioTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/GeometricConsecutiveRatioTask";
import * as FindSumGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat2_suma_types/FindSumGeoTask";
import * as GeometricMiddleTermTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/GeometricMiddleTermTask";
import * as IdentifyTrigRatioFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/IdentifyTrigRatioFromTriangleTask";
import * as FindSinFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/FindSinFromTriangleTask";
import * as FindCosFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/FindCosFromTriangleTask";
import * as FindTanFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/FindTanFromTriangleTask";
import * as TrigValueFromAngleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat2_wartosci_funkcji_types/TrigValueFromAngleTask";
import * as GivenSinFindCosTanTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat3_tozsamosci_types/GivenSinFindCosTanTask";
import * as GivenCosFindSinTanTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat3_tozsamosci_types/GivenCosFindSinTanTask";
import * as GivenTanFindSinCosTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat3_tozsamosci_types/GivenTanFindSinCosTask";
import * as FindCircumradiusRightTriangleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindCircumradiusRightTriangleTask";
import * as FindInradiusRightTriangleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindInradiusRightTriangleTask";
import * as FindCircumradiusEquilateralTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindCircumradiusEquilateralTask";
import * as FindInradiusEquilateralTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindInradiusEquilateralTask";
import * as FindAreaFromBaseAndHeightTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat2_pole_trojkata_types/FindAreaFromBaseAndHeightTask";
import * as FindAreaFromTwoSidesAndAngleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat2_pole_trojkata_types/FindAreaFromTwoSidesAndAngleTask";
import * as FindSideFromTwoSidesAndIncludedAngleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat9_twierdzenie_cosinusow_types/FindSideFromTwoSidesAndIncludedAngleTask";
import * as FindSideFromTwoSidesAndCosineTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat9_twierdzenie_cosinusow_types/FindSideFromTwoSidesAndCosineTask";
import * as TriangleSimilarityTasks from "../../generators/dzial6_planimetria/temat5_skala_i_podobienstwo/podtemat2_podobienstwo_types/SimilarityTasks";
import * as ThalesSimilarityTasks from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat7_tales_i_podobienstwo_types/FindThalesMissingSegmentTask";
import * as SimilarityScaleTasks from "../../generators/dzial6_planimetria/temat5_skala_i_podobienstwo/podtemat3_pola_objetosci_types/ScaleAreaVolumeTasks";
import * as FindInscribedFromCentralAngleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindInscribedFromCentralAngleTask";
import * as FindCentralFromInscribedAngleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindCentralFromInscribedAngleTask";
import * as FindAngleInSemicircleTriangleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindAngleInSemicircleTriangleTask";
import * as FindBaseAngleFromRadiiTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindBaseAngleFromRadiiTask";
import * as FindHiddenAngleInCircleTriangleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindHiddenAngleInCircleTriangleTask";
import * as LengthTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat2_odleglosc_types/LengthTask";
import * as PerimeterTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat2_odleglosc_types/PerimeterTask";
import * as MidpointTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat3_srodek_odcinka_types/MidpointTask";
import * as FindATask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat3_srodek_odcinka_types/FindATask";
import * as FindBTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat3_srodek_odcinka_types/FindBTask";
import * as FindParameterParallelTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/FindParameterParallelTask";
import * as ParallelLineThroughPointTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/ParallelLineThroughPointTask";
import * as FindParameterGeneralLineRelationTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/FindParameterGeneralLineRelationTask";
import * as ReadCircleFromEquationTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/ReadCircleFromEquationTask";
import * as WriteCircleEquationTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/WriteCircleEquationTask";
import * as WriteCircleFromCenterAndPointTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/WriteCircleFromCenterAndPointTask";
import * as WriteCircleFromDiameterTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/WriteCircleFromDiameterTask";
import * as SymmetryCircleTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat4_symetria_types/SymmetryCircleTask";
import * as CuboidVolumeTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat3_objetosc_graniastoslupow_types/CuboidVolumeTask";
import * as RegularPrismVolumeTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat3_objetosc_graniastoslupow_types/RegularPrismVolumeTask";
import * as CubeDiagonalTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat1_wlasciwosci_graniastoslupow_types/CubeDiagonalTask";
import * as CountElementsTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat1_wlasciwosci_graniastoslupow_types/CountElementsTask";
import * as PyramidVolumeFromBaseAreaTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat3_objetosc_ostroslupow_types/PyramidVolumeFromBaseAreaTask";
import * as PyramidHeightFromVolumeTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat3_objetosc_ostroslupow_types/PyramidHeightFromVolumeTask";
import * as CountElementsFromBaseTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat1_wlasnosci_i_klasyfikacja_types/CountElementsFromBaseTask";
import * as VolumeOfCylinderTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat1_walec_types/VolumeOfCylinderTask";
import * as TotalSurfaceAreaOfCylinderTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat1_walec_types/TotalSurfaceAreaOfCylinderTask";
import * as ConeVolumeTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat2_stozek_types/ConeVolumeTask";
import * as ConeHeightFromVolumeTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat2_stozek_types/ConeHeightFromVolumeTask";
import * as CylinderConeVolumeComparisonTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/CylinderConeVolumeComparisonTask";
import * as OutfitMultiplicationTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/OutfitMultiplicationTask";
import * as AdditionOfProductsMealTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/AdditionOfProductsMealTask";
import * as DigitOnceBelowH00Task from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/DigitOnceBelowH00Task";
import * as PermutationRaceTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat2_permutacje_types/PermutationRaceTask";
import * as VariationKDigitNumbersTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat3_wariacje_types/VariationKDigitNumbersTask";
import * as CombinationTeamTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat4_kombinacje_types/CombinationTeamTask";
import * as UrnOneDrawTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat1_podstawy_types/UrnOneDrawTask";
import * as DiceSingleRollTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat1_podstawy_types/DiceSingleRollTask";
import * as TwoDiceSumGreaterTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat1_podstawy_types/TwoDiceSumGreaterTask";
import * as ComplementProbabilityTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat3_zdarzenia_types/ComplementProbabilityTask";
import * as MeanArithmeticRawTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanArithmeticRawTask";
import * as MeanArithmeticWithUnknownTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanArithmeticWithUnknownTask";
import * as MeanWeightedDiaryTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanWeightedDiaryTask";
import * as MeanGeometricRawTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanGeometricRawTask";
import * as MedianTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat2_miary_polozenia_i_zmiennosci_types/MedianTask";
import * as ModeTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat2_miary_polozenia_i_zmiennosci_types/ModeTask";
import * as DivisibilityPreparationTasks from "../../generators/dzial10_dowody/temat3_zadania_uzupelniajace_maturalne/DivisibilityPreparationTasks";
import AbsoluteValuePreparationTheory from "./AbsoluteValuePreparationTheory";
import PercentagesPreparationTheory from "./PercentagesPreparationTheory";
import RootOperationsPreparationTheory from "./RootOperationsPreparationTheory";
import PowersPreparationTheory from "./PowersPreparationTheory";
import LogarithmsPreparationTheory from "./LogarithmsPreparationTheory";
import SpecialProductsPreparationTheory from "../../lessons/Lesson_2_1_2_WzorySkroconego/Lesson1_TeoriaPrzyklady";
import RationalExpressionsEquationsPreparationTheory from "./RationalExpressionsEquationsPreparationTheory";
import QuadraticInequalitiesPreparationTheory from "../../lessons/Lesson_2_3_2_Kwadratowe/Lesson1_TeoriaPrzyklady";
import LinearInequalitiesPreparationTheory from "./LinearInequalitiesPreparationTheory";
import PolynomialEquationsPreparationTheory from "./PolynomialEquationsPreparationTheory";
import LinearSystemsWordProblemsPreparationTheory from "./LinearSystemsWordProblemsPreparationTheory";
import FunctionGraphPreparationTheory from "./FunctionGraphPreparationTheory";
import LinearFunctionPreparationTheory from "./LinearFunctionPreparationTheory";
import QuadraticCanonicalPreparationTheory from "./QuadraticCanonicalPreparationTheory";
import QuadraticFactoredPreparationTheory from "./QuadraticFactoredPreparationTheory";
import QuadraticOptimizationPreparationTheory from "./QuadraticOptimizationPreparationTheory";
import SequenceBasicsPreparationTheory from "./SequenceBasicsPreparationTheory";
import ArithmeticSequencePreparationTheory from "./ArithmeticSequencePreparationTheory";
import GeometricSequencePreparationTheory from "./GeometricSequencePreparationTheory";
import MixedSequencesPreparationTheory from "./MixedSequencesPreparationTheory";
import AcuteAngleTrigPreparationTheory from "./AcuteAngleTrigPreparationTheory";
import TrigIdentitiesPreparationTheory from "../../lessons/Lesson_5_1_4_TozsamosciTrojkat/Lesson1_TeoriaPrzyklady";
import TriangleRadiiPreparationTheory from "./TriangleRadiiPreparationTheory";
import TriangleAreaCosinePreparationTheory from "./TriangleAreaCosinePreparationTheory";
import TriangleSimilarityPreparationTheory from "./TriangleSimilarityPreparationTheory";
import SimilarityScalePreparationTheory from "./SimilarityScalePreparationTheory";
import CircleAnglesPreparationTheory from "./CircleAnglesPreparationTheory";
import AnalyticGeometryPreparationTheory from "./AnalyticGeometryPreparationTheory";
import LinesPositionPreparationTheory from "./LinesPositionPreparationTheory";
import CircleEquationPreparationTheory from "./CircleEquationPreparationTheory";
import PrismsPyramidsPreparationTheory from "./PrismsPyramidsPreparationTheory";
import CylinderConePreparationTheory from "./CylinderConePreparationTheory";
import CombinatoricsPreparationTheory from "./CombinatoricsPreparationTheory";
import ProbabilityBasicsPreparationTheory from "./ProbabilityBasicsPreparationTheory";
import DescriptiveStatisticsPreparationTheory from "./DescriptiveStatisticsPreparationTheory";
import DivisibilityProofsPreparationTheory from "./DivisibilityProofsPreparationTheory";


export { hasMaturaCoursePreparation } from "./maturaCoursePreparationAvailability";

const preparationRegistry = {
  [ABSOLUTE_VALUE_CODE]: {
    code: ABSOLUTE_VALUE_CODE,
    title: "Wartość bezwzględna",
    sectionTitle: "Liczby i działania",
    TheoryComponent: AbsoluteValuePreparationTheory,
    taskPlan: [
      { type: "AbsIntValueTask" },
      { type: "AbsSqrtMinusIntValueTask" },
      {
        type: "AbsSqrtAbsPairOpenTask",
        generationOptions: { mode: "plus" },
      },
      {
        type: "AbsSqrtAbsPairOpenTask",
        generationOptions: { mode: "minus" },
      },
      {
        type: "SolveAbsoluteLinearTask",
        generationOptions: { forceUnitXCoefficient: true, sign: "-" },
      },
      {
        type: "SolveAbsoluteLinearTask",
        generationOptions: {
          forceNonUnitXCoefficient: true,
          forceOutsideCoefficient: true,
          sign: "+",
        },
      },
    ],
    generators: {
      AbsIntValueTask,
      AbsSqrtMinusIntValueTask,
      AbsSqrtAbsPairOpenTask,
      SolveAbsoluteLinearTask,
    },
  },
  [ROOT_OPERATIONS_CODE]: {
    code: ROOT_OPERATIONS_CODE,
    title: "Działania na pierwiastkach",
    sectionTitle: "Liczby i działania",
    TheoryComponent: RootOperationsPreparationTheory,
    taskPlan: [
      {
        type: "ExtractRootFactorTask",
        generationOptions: { degree: 2 },
      },
      {
        type: "ExtractRootFactorTask",
        generationOptions: { degree: 3 },
      },
      {type:"OddRootValueTask",generationOptions:{degree:3}},
      {type:"OddRootValueTask",generationOptions:{degree:5}},
      {type:"FractionRootProductTask",generationOptions:{type:"FractionRootProductTask",basic:true}},
      {type:"CubeRootQuotientTask",generationOptions:{type:"CubeRootQuotientTask",basic:true}},
      { type: "RootSumSquareClosedTask" },
      { type: "RootSumCubeClosedTask" },
      { type: "RootBinomialOpenTask" },
    ],
    generators: {
      ...OddRoots.registry,
      FractionRootProductTask:FractionRoots.registry.FractionRootProductTask,
      CubeRootQuotientTask:FractionRoots.registry.CubeRootQuotientTask,
      RootSumCubeClosedTask,
      ExtractRootFactorTask,
      RootSumSquareClosedTask,
      RootBinomialOpenTask,
    },
  },
  [PERCENTAGES_CODE]: {
    code: PERCENTAGES_CODE,
    title: "Procenty",
    sectionTitle: "Liczby i działania",
    TheoryComponent: PercentagesPreparationTheory,
    taskPlan: [
      {
        type: "PercentOfNumberTask",
        generationOptions: { difficulty: "easy", requireIntegerResult: true },
      },
      { type: "PercentWhatPartTask", generationOptions: { difficulty: "easy" } },
      { type: "PercentComparisonRelativeTask" },
      { type: "FindFinalAmountSimpleInterestTask" },
      { type: "FindFinalAmountSingleCapitalizationTask" },
      {type:"FindInitialCapitalTask"},
      {type:"FindAnnualInterestRateTask",generationOptions:{type:"FindAnnualInterestRateTask"}},
    ],
    generators: {
      PercentOfNumberTask,
      PercentWhatPartTask,
      PercentComparisonRelativeTask,
      ...InverseInterest.registry,
      FindFinalAmountSimpleInterestTask,
      FindFinalAmountSingleCapitalizationTask,
    },
  },
  [POWERS_CODE]: {
    code: POWERS_CODE,
    title: "Potęgi",
    sectionTitle: "Liczby i działania",
    TheoryComponent: PowersPreparationTheory,
    taskPlan: [
      { type: "PowSumExponentsTask" },
      { type: "PowDiffExponentsTask" },
      { type: "PowPowerOfPowerTask" },
      { type: "NegativeExponentBasicTask" },
      {
        type: "PowerFamilyPreparationTask",
        generationOptions: { mode: "product" },
      },
      {
        type: "PowerFamilyPreparationTask",
        generationOptions: { mode: "quotient" },
      },
      {type:"PowFactorSumTask",generationOptions:{mode:"factor"}},
      {type:"PowFactorSumTask",generationOptions:{mode:"quotient"}},
      {
        type: "RadicalToRationalPowerTask",
        generationOptions: { requiredBase: 8 },
      },
    ],
    generators: {
      ...FactorSum.registry,
      PowSumExponentsTask,
      PowDiffExponentsTask,
      PowPowerOfPowerTask,
      NegativeExponentBasicTask,
      PowerFamilyPreparationTask,
      RadicalToRationalPowerTask,
    },
  },
  [LOGARITHMS_CODE]: {
    code: LOGARITHMS_CODE,
    title: "Logarytmy",
    sectionTitle: "Liczby i działania",
    TheoryComponent: LogarithmsPreparationTheory,
    taskPlan: [
      {
        type: "LogSimpleTask",
        generationOptions: { variant: "A", sign: "positive" },
      },
      {type:"LogSimpleTask",generationOptions:{variant:"A",sign:"negative"}},
      {type:"LogComputePowerTask",generationOptions:{mode:"fractions"}},
      {type:"LogComputePowerTask",generationOptions:{mode:"roots"}},
      { type: "LogNumberAsLogTask" },
      { type: "LogPropSumTask" },
      { type: "LogPropDiffTask" },
      {
        type: "LogPropCoefTask",
        generationOptions: { direction: "intoArgument" },
      },
      {type:"LogPropCoefMixTask"},
    ],
    generators: {
      LogComputePowerTask,
      LogPropCoefMixTask,
      LogSimpleTask,
      LogNumberAsLogTask,
      LogPropSumTask,
      LogPropDiffTask,
      LogPropCoefTask,
    },
  },
  [SPECIAL_PRODUCTS_CODE]: {
    code: SPECIAL_PRODUCTS_CODE,
    title: "Wzory skróconego mnożenia",
    sectionTitle: "Algebra",
    TheoryComponent: SpecialProductsPreparationTheory,
    taskPlan: [
      { type: "SimplifyParenthesesTask" },
      { type: "MultiplyBinomialsTask" },
      { type: "SquareOfSumLiteralTask" },
      { type: "SquareOfDifferenceTask" },
      { type: "DifferenceOfSquaresTask" },
      { type: "SquareOfSumTask" },
      { type: "SquareOfDifferenceSqrtTask" },
      { type: "DifferenceOfSquaresWithRootTask" },
    ],
    generators: {
      SimplifyParenthesesTask,
      MultiplyBinomialsTask,
      SquareOfSumLiteralTask,
      SquareOfDifferenceTask,
      DifferenceOfSquaresTask,
      SquareOfSumTask,
      SquareOfDifferenceSqrtTask,
      DifferenceOfSquaresWithRootTask,
      MixedSpecialProductsSqrtTask,
    },
  },
  [RATIONAL_EXPRESSIONS_EQUATIONS_CODE]: {
    code: RATIONAL_EXPRESSIONS_EQUATIONS_CODE,
    title: "Wyrażenia i równania wymierne",
    sectionTitle: "Algebra",
    TheoryComponent: RationalExpressionsEquationsPreparationTheory,
    taskPlan: [
      { type: "CancelBracketFactorTask" },
      { type: "DiffSquaresOverSumOrDiffTask" },
      { type: "RationalSolveAndDomainLinearTask" },
      { type: "RationalSolveAndDomainLinearConstTask" },
      { type: "RationalTwoFracsQuadraticTask" },
    ],
    generators: {
      CancelBracketFactorTask,
      DiffSquaresOverSumOrDiffTask,
      RationalSolveAndDomainLinearTask,
      RationalSolveAndDomainLinearConstTask,
      RationalTwoFracsQuadraticTask,
    },
  },
  [QUADRATIC_INEQUALITIES_CODE]: {
    code: QUADRATIC_INEQUALITIES_CODE,
    title: "Nierówności kwadratowe",
    sectionTitle: "Algebra",
    TheoryComponent: QuadraticInequalitiesPreparationTheory,
    taskPlan: [
      { type: "SolveQuadraticTwoSolutionsTask" },
      { type: "SolveRearrangedQuadraticTask" },
      {
        type: "QuadraticFactoredInequalityTask",
        generationOptions: { kind: "ge" },
      },
      {
        type: "QuadraticGeneralInequalityTask",
        generationOptions: { kind: "lt" },
      },
      {
        type: "RearrangedQuadraticInequalityTask",
        generationOptions: { kind: "le" },
      },
    ],
    generators: {
      SolveQuadraticTwoSolutionsTask,
      SolveRearrangedQuadraticTask,
      QuadraticFactoredInequalityTask,
      QuadraticGeneralInequalityTask,
      RearrangedQuadraticInequalityTask,
    },
  },
  [LINEAR_INEQUALITIES_CODE]: {
    code: LINEAR_INEQUALITIES_CODE,
    title: "Nierówności liniowe",
    sectionTitle: "Algebra",
    TheoryComponent: LinearInequalitiesPreparationTheory,
    taskPlan: [
      { type: "SolveTwoSidedLinearEquationTask" },
      { type: "SolveLinearEquationWithParenthesesTask" },
      { type: "LinearEquationFractionsTask" },
      { type: "LinearInequalitySimpleTask", generationOptions: { kind: "le" } },
      { type: "LinearInequalityTwoSidesTask", generationOptions: { kind: "gt" } },
      { type: "LinearInequalityFractionsTask", generationOptions: { kind: "le" } },
    ],
    generators: {
      SolveTwoSidedLinearEquationTask,
      SolveLinearEquationWithParenthesesTask,
      LinearEquationFractionsTask,
      LinearInequalitySimpleTask,
      LinearInequalityTwoSidesTask,
      LinearInequalityFractionsTask,
    },
  },
  [POLYNOMIAL_OPERATIONS_CODE]: {
    code:POLYNOMIAL_OPERATIONS_CODE,title:"Działania na wielomianach",sectionTitle:"Algebra",
    TheoryComponent:PolynomialOperationsPreparationTheory,
    taskPlan:[
      {type:"PolynomialValueTask",generationOptions:{variant:"integer"}},
      {type:"MultiplyBinomialsTask"},
      {type:"SimplifyParenthesesTask"},
    ],
    generators:{PolynomialValueTask,MultiplyBinomialsTask,SimplifyParenthesesTask},
  },
  [POLYNOMIAL_EQUATIONS_CODE]: {
    code: POLYNOMIAL_EQUATIONS_CODE,
    title: "Równania wielomianowe",
    sectionTitle: "Algebra",
    TheoryComponent: PolynomialEquationsPreparationTheory,
    taskPlan: [
      {
        type: "ProductFactorsPolynomialEquationTask",
        generationOptions: { variant: "simpleLinear", factorCount: 2 },
      },
      {
        type: "ProductFactorsPolynomialEquationTask",
        generationOptions: { variant: "linearCoefficients", factorCount: 3 },
      },
      {
        type: "ProductFactorsPolynomialEquationTask",
        generationOptions: {
          variant: "quadraticBlockSolve",
          outsideRootCount: 1,
          quadraticMode: "regularDelta",
        },
      },
    ],
    generators: {
      ProductFactorsPolynomialEquationTask,
    },
  },
  [LINEAR_SYSTEMS_WORD_PROBLEMS_CODE]: {
    code: LINEAR_SYSTEMS_WORD_PROBLEMS_CODE,
    title: "Układy równań liniowych",
    sectionTitle: "Algebra",
    TheoryComponent: LinearSystemsWordProblemsPreparationTheory,
    taskPlan: [
      { type: "LinearSystemSubstitutionEasyTask" },
      { type: "TwoNumbersSumDiffTask" },
      { type: "TicketsSalesTask" },
    ],
    generators: {
      LinearSystemSubstitutionEasyTask,
      TwoNumbersSumDiffTask,
      TicketsSalesTask,
    },
  },
  [FUNCTION_GRAPH_CODE]: {
    code: FUNCTION_GRAPH_CODE,
    title: "Wykres funkcji",
    sectionTitle: "Funkcje",
    TheoryComponent: FunctionGraphPreparationTheory,
    taskPlan: [
      { type: "ReadDomainFromGraphTask" },
      { type: "ReadRangeFromGraphTask" },
      { type: "ReadFunctionValueFromGraphTask" },
      { type: "ReadZeroFromGraphTask" },
      { type: "ReadMonotonicityFromGraphTask" },
      { type: "ReadSignIntervalFromGraphTask" },
      { type: "ReadFunctionComparisonIntervalFromGraphTask" },
      { type: "ReadMaximumOnIntervalFromGraphTask" },
    ],
    generators: {
      ReadDomainFromGraphTask,
      ReadRangeFromGraphTask,
      ReadFunctionValueFromGraphTask,
      ReadZeroFromGraphTask,
      ReadMonotonicityFromGraphTask,
      ReadSignIntervalFromGraphTask,
      ReadFunctionComparisonIntervalFromGraphTask,
      ReadMaximumOnIntervalFromGraphTask,
    },
  },
  [LINEAR_FUNCTION_CODE]: {
    code: LINEAR_FUNCTION_CODE,
    title: "Funkcja liniowa",
    sectionTitle: "Funkcje",
    TheoryComponent: LinearFunctionPreparationTheory,
    taskPlan: [
      { type: "LinearComputeValueTask" },
      { type: "LinearZeroTask" },
      { type: "LinearSlopeTask" },
      { type: "LinearFromTwoPointsTask" },
      {
        type: "ShiftFunctionByVectorTask",
        generationOptions: { variant: "xy", kind: "linear" },
      },
    ],
    generators: {
      LinearComputeValueTask,
      LinearZeroTask,
      LinearSlopeTask,
      LinearFromTwoPointsTask,
      ShiftFunctionByVectorTask,
    },
  },
  [QUADRATIC_CANONICAL_CODE]: {
    code: QUADRATIC_CANONICAL_CODE,
    title: "Postać kanoniczna",
    sectionTitle: "Funkcje",
    TheoryComponent: QuadraticCanonicalPreparationTheory,
    taskPlan: [
      { type: "FindAPQFromCanonicalTask" },
      { type: "FindVertexFromGeneralTask" },
      { type: "TransformCanonicalToGeneralTask" },
      { type: "TransformGeneralToCanonicalTask" },
    ],
    generators: {
      FindAPQFromCanonicalTask,
      FindVertexFromGeneralTask,
      TransformCanonicalToGeneralTask,
      TransformGeneralToCanonicalTask,
    },
  },
  [QUADRATIC_FACTORED_CODE]: {
    code: QUADRATIC_FACTORED_CODE,
    title: "Postać iloczynowa",
    sectionTitle: "Funkcje",
    TheoryComponent: QuadraticFactoredPreparationTheory,
    taskPlan: [
      { type: "FindAX1X2FromFactoredTask" },
      { type: "FindRootsFromGeneralTask" },
      { type: "TransformFactoredToGeneralTask" },
      { type: "TransformGeneralToFactoredTask" },
    ],
    generators: {
      FindAX1X2FromFactoredTask,
      FindRootsFromGeneralTask,
      TransformFactoredToGeneralTask,
      TransformGeneralToFactoredTask,
    },
  },
  [QUADRATIC_OPTIMIZATION_CODE]: {
    code: QUADRATIC_OPTIMIZATION_CODE,
    title: "Optymalizacja",
    sectionTitle: "Funkcje",
    TheoryComponent: QuadraticOptimizationPreparationTheory,
    taskPlan: [
      { type: "QuadraticExtremeArgTask" },
      { type: "QuadraticExtremeValueTask" },
      { type: "QuadraticExtremeOnIntervalTask" },
      {
        types: ["FenceMaxAreaAgainstWallTask", "OptimizationPairsTask"],
        generationOptions: { variant: "SUM_SQ_SUM" },
      },
    ],
    generators: {
      QuadraticExtremeArgTask,
      QuadraticExtremeValueTask,
      QuadraticExtremeOnIntervalTask,
      FenceMaxAreaAgainstWallTask,
      OptimizationPairsTask,
    },
  },
  [SEQUENCE_BASICS_CODE]: {
    code: SEQUENCE_BASICS_CODE,
    title: "Definicja ciągu",
    sectionTitle: "Ciągi",
    TheoryComponent: SequenceBasicsPreparationTheory,
    taskPlan: [
      { type: "FindNthTermFromFormulaTask", generationOptions: { forceType: "linear" } },
      { type: "SumInitialTermsFromFormulaTask" },
      { type: "CompleteRecursiveTask", generationOptions: { targetIndex: 2 } },
      { type: "CompleteRecursiveTask", generationOptions: { minTargetIndex: 3, maxTargetIndex: 5 } },
    ],
    generators: {
      FindNthTermFromFormulaTask,
      FindNthTermFromLinearTask: FindNthTermFromFormulaTask,
      SumInitialTermsFromFormulaTask,
      CompleteRecursiveTask,
    },
  },
  [ARITHMETIC_SEQUENCE_CODE]: {
    code: ARITHMETIC_SEQUENCE_CODE,
    title: "Ciąg arytmetyczny",
    sectionTitle: "Ciągi",
    TheoryComponent: ArithmeticSequencePreparationTheory,
    taskPlan: [
      { type: "FindNthTermTask", generationOptions: { simple: true } },
      { type: "FindDifferenceTask" },
      { type: "ArithmeticMiddleTermTask" },
      { type: "ArithmeticMiddleTermEquationTask" },
      { type: "FindSumTask" },
    ],
    generators: {
      FindNthTermTask,
      FindDifferenceTask,
      ArithmeticMiddleTermTask,
      ArithmeticMiddleTermEquationTask,
      FindSumTask,
    },
  },
  [GEOMETRIC_SEQUENCE_CODE]: {
    code: GEOMETRIC_SEQUENCE_CODE,
    title: "Ciąg geometryczny",
    sectionTitle: "Ciągi",
    TheoryComponent: GeometricSequencePreparationTheory,
    taskPlan: [
      { type: "FindNthTermGeoTask", generationOptions: { simple: true } },
      { type: "GeometricConsecutiveRatioTask" },
      { type: "GeometricMiddleTermTask" },
      { type: "FindSumGeoTask", generationOptions: { simple: true } },
    ],
    generators: {
      FindNthTermGeoTask,
      GeometricConsecutiveRatioTask,
      GeometricMiddleTermTask,
      FindSumGeoTask,
    },
  },
  [MIXED_SEQUENCES_CODE]: {
    code: MIXED_SEQUENCES_CODE,
    title: "Ciągi arytmetyczne i geometryczne",
    sectionTitle: "Ciągi",
    TheoryComponent: MixedSequencesPreparationTheory,
    taskPlan: [
      { type: "ArithmeticMiddleTermTask" },
      { type: "ArithmeticMiddleTermEquationTask" },
      { type: "GeometricMiddleTermTask" },
      { type: "GeometricConsecutiveRatioTask" },
    ],
    generators: {
      ArithmeticMiddleTermTask,
      ArithmeticMiddleTermEquationTask,
      GeometricMiddleTermTask,
      GeometricConsecutiveRatioTask,
    },
  },
  [ACUTE_ANGLE_TRIG_CODE]: {
    code: ACUTE_ANGLE_TRIG_CODE,
    title: "Trygonometria kąta ostrego",
    sectionTitle: "Trygonometria",
    TheoryComponent: AcuteAngleTrigPreparationTheory,
    taskPlan: [
      { type: "IdentifyTrigRatioFromTriangleTask", generationOptions: { kind: "sin" } },
      { type: "IdentifyTrigRatioFromTriangleTask", generationOptions: { kind: "cos" } },
      { type: "IdentifyTrigRatioFromTriangleTask", generationOptions: { kind: "tan" } },
      { type: "FindSinFromTriangleTask" },
      { type: "FindCosFromTriangleTask" },
      { type: "FindTanFromTriangleTask" },
      { type: "TrigValueFromAngleTask", generationOptions: { func: "sin", acuteOnly: true } },
      { type: "TrigValueFromAngleTask", generationOptions: { func: "cos", acuteOnly: true } },
      { type: "TrigValueFromAngleTask", generationOptions: { func: "tan", acuteOnly: true } },
    ],
    generators: {
      IdentifyTrigRatioFromTriangleTask,
      FindSinFromTriangleTask,
      FindCosFromTriangleTask,
      FindTanFromTriangleTask,
      TrigValueFromAngleTask,
    },
  },
  [TRIG_IDENTITIES_CODE]: {
    code: TRIG_IDENTITIES_CODE,
    title: "Tożsamości trygonometryczne",
    sectionTitle: "Trygonometria",
    TheoryComponent: TrigIdentitiesPreparationTheory,
    taskPlan: [
      { type: "GivenSinFindCosTanTask", generationOptions: { variant: "I" } },
      { type: "GivenCosFindSinTanTask", generationOptions: { variant: "I" } },
      { type: "GivenTanFindSinCosTask", generationOptions: { variant: "I" } },
    ],
    generators: {
      GivenSinFindCosTanTask,
      GivenCosFindSinTanTask,
      GivenTanFindSinCosTask,
    },
  },
  [TRIANGLE_RADII_CODE]: {
    code: TRIANGLE_RADII_CODE,
    title: "Promienie w trójkątach",
    sectionTitle: "Planimetria",
    TheoryComponent: TriangleRadiiPreparationTheory,
    taskPlan: [
      { type: "FindCircumradiusRightTriangleTask" },
      { type: "FindInradiusRightTriangleTask" },
      { type: "FindCircumradiusEquilateralTask" },
      { type: "FindInradiusEquilateralTask" },
    ],
    generators: {
      FindCircumradiusRightTriangleTask,
      FindInradiusRightTriangleTask,
      FindCircumradiusEquilateralTask,
      FindInradiusEquilateralTask,
    },
  },
  [TRIANGLE_SIMILARITY_CODE]: {
    code: TRIANGLE_SIMILARITY_CODE,
    title: "Podobieństwo trójkątów",
    sectionTitle: "Planimetria",
    TheoryComponent: TriangleSimilarityPreparationTheory,
    taskPlan: [
      {
        type: "TriangleAngleSimilarityCheckTask",
        generationOptions: { type: "TriangleAngleSimilarityCheckTask" },
      },
      {
        type: "TriangleSSSSimilarityCheckTask",
        generationOptions: { type: "TriangleSSSSimilarityCheckTask" },
      },
      {
        type: "FindThalesPreparationMixedTask",
        generationOptions: {
          type: "FindThalesPreparationMixedTask",
          mode: "talesPreparationMixed",
        },
      },
      {
        type: "FindSimilarPreparationMixedTask",
        generationOptions: {
          type: "FindSimilarPreparationMixedTask",
          mode: "similarPreparationMixed",
        },
      },
      {
        type: "FindThalesCrossedPreparationTask",
        generationOptions: {
          type: "FindThalesCrossedPreparationTask",
          mode: "crossedSegment",
        },
      },
    ],
    generators: {
      TriangleAngleSimilarityCheckTask: TriangleSimilarityTasks,
      TriangleSSSSimilarityCheckTask: TriangleSimilarityTasks,
      // Starsze zapisane podejścia nadal korzystają z tych trzech typów.
      CorrespondingTriangleSideTask: TriangleSimilarityTasks,
      CorrespondingTriangleAngleTask: TriangleSimilarityTasks,
      SimilarTriangleSideTask: TriangleSimilarityTasks,
      FindThalesSegmentTask: ThalesSimilarityTasks,
      FindThalesPartWholeTask: ThalesSimilarityTasks,
      FindThalesPreparationMixedTask: ThalesSimilarityTasks,
      FindSimilarBasesEasyTask: ThalesSimilarityTasks,
      FindSimilarPreparationMixedTask: ThalesSimilarityTasks,
      FindThalesCrossedPreparationTask: ThalesSimilarityTasks,
    },
  },
  [TRIANGLE_AREA_COSINE_CODE]: {
    code: TRIANGLE_AREA_COSINE_CODE,
    title: "Pole trójkąta i twierdzenie cosinusów",
    sectionTitle: "Planimetria",
    TheoryComponent: TriangleAreaCosinePreparationTheory,
    taskPlan: [
      { type: "FindAreaFromBaseAndHeightTask" },
      {
        type: "FindAreaFromTwoSidesAndAngleTask",
        generationOptions: { allowedAngles: [30, 45, 60] },
      },
      { type: "FindSideFromTwoSidesAndIncludedAngleTask" },
      { type: "FindSideFromTwoSidesAndCosineTask" },
    ],
    generators: {
      FindAreaFromBaseAndHeightTask,
      FindAreaFromTwoSidesAndAngleTask,
      FindSideFromTwoSidesAndIncludedAngleTask,
      FindSideFromTwoSidesAndCosineTask,
    },
  },
  [SIMILARITY_SCALE_CODE]: {
    code: SIMILARITY_SCALE_CODE,
    title: "Skala podobieństwa",
    sectionTitle: "Planimetria",
    TheoryComponent: SimilarityScalePreparationTheory,
    taskPlan: [
      {
        type: "SimilarPerimeterFromScaleTask",
        generationOptions: { type: "SimilarPerimeterFromScaleTask" },
      },
      {
        type: "DirectedPerimeterFromScaleTask",
        generationOptions: { type: "DirectedPerimeterFromScaleTask" },
      },
      {
        type: "ScaleFromPerimeterRatioTask",
        generationOptions: { type: "ScaleFromPerimeterRatioTask" },
      },
      {
        type: "AreaFromPerimeterRatioTask",
        generationOptions: { type: "AreaFromPerimeterRatioTask" },
      },
      {
        type: "ScaleFromAreaRatioTask",
        generationOptions: { type: "ScaleFromAreaRatioTask" },
      },
      {
        type: "SolidVolumeFromLengthRatioTask",
        generationOptions: { type: "SolidVolumeFromLengthRatioTask" },
      },
      {
        type: "SolidVolumeFromSurfaceRatioTask",
        generationOptions: { type: "SolidVolumeFromSurfaceRatioTask" },
      },
    ],
    generators: {
      SimilarPerimeterFromScaleTask: SimilarityScaleTasks,
      DirectedPerimeterFromScaleTask: SimilarityScaleTasks,
      ScaleFromPerimeterRatioTask: SimilarityScaleTasks,
      AreaFromPerimeterRatioTask: SimilarityScaleTasks,
      ScaleFromAreaRatioTask: SimilarityScaleTasks,
      SolidVolumeFromLengthRatioTask: SimilarityScaleTasks,
      SolidVolumeFromSurfaceRatioTask: SimilarityScaleTasks,
    },
  },
  [CIRCLE_ANGLES_CODE]: {
    code: CIRCLE_ANGLES_CODE,
    title: "Kąty w okręgu",
    sectionTitle: "Planimetria",
    TheoryComponent: CircleAnglesPreparationTheory,
    taskPlan: [
      { type: "FindInscribedFromCentralAngleTask" },
      { type: "FindCentralFromInscribedAngleTask" },
      { type: "FindBaseAngleFromRadiiTask" },
      { type: "FindAngleInSemicircleTriangleTask" },
      { type: "FindHiddenAngleInCircleTriangleTask" },
    ],
    generators: {
      FindInscribedFromCentralAngleTask,
      FindCentralFromInscribedAngleTask,
      FindAngleInSemicircleTriangleTask,
      FindBaseAngleFromRadiiTask,
      FindHiddenAngleInCircleTriangleTask,
    },
  },
  [ANALYTIC_GEOMETRY_APPLICATIONS_CODE]: {
    code: ANALYTIC_GEOMETRY_APPLICATIONS_CODE,
    title: "Zastosowania geometrii analitycznej",
    sectionTitle: "Geometria analityczna",
    TheoryComponent: AnalyticGeometryPreparationTheory,
    taskPlan: [
      { type: "LengthTask" },
      { type: "PerimeterTask" },
      { type: "MidpointTask", generationOptions: { mode: "second_fourth" } },
      { types: ["FindATask", "FindBTask"] },
    ],
    generators: {
      LengthTask,
      PerimeterTask,
      MidpointTask,
      FindATask,
      FindBTask,
    },
  },
  [LINES_POSITION_CODE]: {
    code: LINES_POSITION_CODE,
    title: "Położenie prostych",
    sectionTitle: "Geometria analityczna",
    TheoryComponent: LinesPositionPreparationTheory,
    taskPlan: [
      { type: "FindParameterParallelTask" },
      { type: "ParallelLineThroughPointTask" },
      { type: "FindParameterGeneralLineRelationTask", generationOptions: { relation: "parallel" } },
    ],
    generators: {
      FindParameterParallelTask,
      ParallelLineThroughPointTask,
      FindParameterGeneralLineRelationTask,
    },
  },
  [CIRCLE_EQUATION_CODE]: {
    code: CIRCLE_EQUATION_CODE,
    title: "Równanie okręgu",
    sectionTitle: "Geometria analityczna",
    TheoryComponent: CircleEquationPreparationTheory,
    taskPlan: [
      { type: "ReadCircleFromEquationTask" },
      { type: "WriteCircleEquationTask" },
      { type: "SymmetryCircleTask" },
      { type: "WriteCircleFromCenterAndPointTask" },
      { type: "WriteCircleFromDiameterTask" },
    ],
    generators: {
      ReadCircleFromEquationTask,
      WriteCircleEquationTask,
      SymmetryCircleTask,
      WriteCircleFromCenterAndPointTask,
      WriteCircleFromDiameterTask,
    },
  },
  [PRISMS_PYRAMIDS_CODE]: {
    code: PRISMS_PYRAMIDS_CODE,
    title: "Graniastosłupy i ostrosłupy",
    sectionTitle: "Stereometria",
    TheoryComponent: PrismsPyramidsPreparationTheory,
    taskPlan: [
      { type: "CuboidVolumeTask" },
      { type: "RegularPrismVolumeTask" },
      { type: "CubeDiagonalTask" },
      { type: "PyramidVolumeFromBaseAreaTask" },
      { type: "PyramidHeightFromVolumeTask" },
      { type: "CountElementsTask" },
      { type: "CountElementsFromBaseTask" },
    ],
    generators: {
      CuboidVolumeTask,
      RegularPrismVolumeTask,
      CubeDiagonalTask,
      PyramidVolumeFromBaseAreaTask,
      PyramidHeightFromVolumeTask,
      CountElementsTask,
      CountElementsFromBaseTask,
    },
  },
  [CYLINDER_CONE_CODE]: {
    code: CYLINDER_CONE_CODE,
    title: "Walce i stożki",
    sectionTitle: "Stereometria",
    TheoryComponent: CylinderConePreparationTheory,
    taskPlan: [
      { type: "VolumeOfCylinderTask" },
      { type: "TotalSurfaceAreaOfCylinderTask" },
      { type: "ConeVolumeTask" },
      { type: "ConeHeightFromVolumeTask" },
      { type: "CylinderConeVolumeComparisonTask" },
    ],
    generators: {
      VolumeOfCylinderTask,
      TotalSurfaceAreaOfCylinderTask,
      ConeVolumeTask,
      ConeHeightFromVolumeTask,
      CylinderConeVolumeComparisonTask,
    },
  },
  [COMBINATORICS_CODE]: {
    code: COMBINATORICS_CODE,
    title: "Kombinatoryka",
    sectionTitle: "Prawdopodobieństwo, statystyka i kombinatoryka",
    TheoryComponent: CombinatoricsPreparationTheory,
    taskPlan: [
      { type: "OutfitMultiplicationTask" },
      { type: "AdditionOfProductsMealTask" },
      { type: "PermutationRaceTask" },
      { type: "VariationKDigitNumbersTask" },
      { type: "DigitOnceBelowH00Task" },
      { type: "CombinationTeamTask" },
    ],
    generators: {
      OutfitMultiplicationTask,
      AdditionOfProductsMealTask,
      PermutationRaceTask,
      VariationKDigitNumbersTask,
      DigitOnceBelowH00Task,
      CombinationTeamTask,
    },
  },
  [PROBABILITY_BASICS_CODE]: {
    code: PROBABILITY_BASICS_CODE,
    title: "Podstawy rachunku prawdopodobieństwa",
    sectionTitle: "Prawdopodobieństwo, statystyka i kombinatoryka",
    TheoryComponent: ProbabilityBasicsPreparationTheory,
    taskPlan: [
      { type: "UrnOneDrawTask" },
      { type: "DiceSingleRollTask" },
      { type: "TwoDiceSumGreaterTask" },
      { type: "ComplementProbabilityTask" },
    ],
    generators: {
      UrnOneDrawTask,
      DiceSingleRollTask,
      TwoDiceSumGreaterTask,
      ComplementProbabilityTask,
    },
  },
  [DESCRIPTIVE_STATISTICS_CODE]: {
    code: DESCRIPTIVE_STATISTICS_CODE,
    title: "Średnia, mediana i dominanta",
    sectionTitle: "Prawdopodobieństwo i statystyka",
    TheoryComponent: DescriptiveStatisticsPreparationTheory,
    taskPlan: [
      { type: "MeanArithmeticRawTask" },
      { type: "MeanArithmeticWithUnknownTask" },
      { type: "MeanWeightedDiaryTask" },
      { type: "MedianTask" },
      { type: "ModeTask" },
      {
        type: "MeanGeometricRawTask",
        generationOptions: { basic: true },
      },
    ],
    generators: {
      MeanArithmeticRawTask,
      MeanArithmeticWithUnknownTask,
      MeanWeightedDiaryTask,
      MedianTask,
      ModeTask,
      MeanGeometricRawTask,
    },
  },
  [DIVISIBILITY_PROOFS_CODE]: {
    code: DIVISIBILITY_PROOFS_CODE,
    title: "Dowody podzielności",
    sectionTitle: "Dowody matematyczne",
    TheoryComponent: DivisibilityProofsPreparationTheory,
    taskPlan: [
      {
        type: "DivisibilityRemainderFormTask",
        generationOptions: { type: "DivisibilityRemainderFormTask" },
      },
      {
        type: "IndependentRemaindersTask",
        generationOptions: { type: "IndependentRemaindersTask" },
      },
      {
        type: "ComplementaryRemaindersProofTask",
        generationOptions: { type: "ComplementaryRemaindersProofTask" },
      },
      {
        type: "ConsecutiveProductProofTask",
        generationOptions: { type: "ConsecutiveProductProofTask" },
      },
    ],
    generators: {
      DivisibilityRemainderFormTask: DivisibilityPreparationTasks,
      IndependentRemaindersTask: DivisibilityPreparationTasks,
      ComplementaryRemaindersProofTask: DivisibilityPreparationTasks,
      ConsecutiveProductProofTask: DivisibilityPreparationTasks,
    },
  },
};

export function getMaturaCoursePreparation(code) {
  return preparationRegistry[getMaturaCourseCode(String(code || ""))] || null;
}

export function getMaturaCoursePreparationTaskRegistry(code) {
  return getMaturaCoursePreparation(code)?.generators || {};
}

// Snapshot quizu jest odtwarzany poza stroną konkretnego przygotowania, więc
// nie ma już przekazanego lokalnego rejestru runnera. Udostępniamy jeden
// rejestr wszystkich adapterów przygotowawczych, aby każdy zapisany typ mógł
// ponownie wyrenderować treść, odpowiedzi i wyjaśnienie.
export function getMaturaCoursePreparationSnapshotRegistry() {
  return Object.values(preparationRegistry).reduce((registry, config) => ({
    ...registry,
    ...(config?.generators || {}),
  }), {});
}

export function generateMaturaCoursePreparationTasks(code) {
  const config = getMaturaCoursePreparation(code);
  if (!config) return [];

  return config.taskPlan.map(({ type, types, generationOptions }, courseSlot) => {
    const availableTypes = Array.isArray(types) && types.length ? types : [type];
    const selectedType = availableTypes.length === 1
      ? availableTypes[0]
      : availableTypes[Math.floor(Math.random() * availableTypes.length)];
    const generator = config.generators[selectedType];
    const task = generator.generateTask({
      ...(generationOptions || {}),
      courseSlot,
    });
    return { ...task, type: task?.type || selectedType };
  });
}
